import ContentUpload from 'module/ContentUpload/ContentUpload';

import { useEffect } from 'react';

import { Form } from 'antd';
import { Input } from 'components';
import { useIntl } from 'react-intl';
import { useGetArticleContentQuery, useGetOfferQuery } from 'services';
import ArticleOrderMediaWrapper from 'components/ArticleOrderMedia/ArticleOrderMediaWrapper';
import { useMediaOfferPermission } from 'hooks';

const { TextArea } = Input;

const CommitteeOpinionExtras = ({ offerID }) => {
  const form = Form.useFormInstance();
  const { formatMessage } = useIntl();
  const { data } = useGetArticleContentQuery(
    {
      offerID,
    },
    {
      skip: !offerID,
    }
  );
  // Medya teklifi yetkisi diğer ekranlarla (AfterCopyright) tek kaynaktan türetilir: sabit rol/true yerine
  // maddenin gerçek statü × rol eşleşmesi. offer gelene kadar hook güvenli şekilde salt-görüntüleme döner.
  const { data: offer } = useGetOfferQuery(offerID, { skip: !offerID });
  const mediaOfferPermission = useMediaOfferPermission(offer);
  useEffect(() => {
    if (data) {
      form.setFieldsValue({
        itemFile: data.contents.find((item) => item.type === 0),
        idCard: data.contents.find((item) => item.type === 1),
      });
    }
  }, [data, form]);

  return (
    <>
      <ContentUpload id={offerID} />
      <ArticleOrderMediaWrapper
        offerID={offerID}
        permission={mediaOfferPermission}
        isContentSend
        isCommiteeControlColumnsVisible={!mediaOfferPermission.isReadOnly}
        hideContentFiles
      />
      <Form.Item
        name="mediaOfferDescription"
        className="gx-mb-4"
        rules={[
          {
            min: 50,
            message: formatMessage({
              id: 'article.reasonLengthMessageShort',
            }),
          },
        ]}
        normalize={(value) => (value.trim() === '' ? undefined : value)}
      >
        <TextArea
          rows={8}
          placeholder="Medya teklifi ile ilgili görüş belirtiniz"
          showCount
        />
      </Form.Item>
    </>
  );
};

export default CommitteeOpinionExtras;
